var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./styles.scss";
import * as PrimitiveSelect from "@react-components/primitives/Forms/Select/Select";
import { ScrollArea } from "@react-components/primitives/ScrollArea/ScrollArea";
import { ConditionalWrap } from "@react-components/primitives/ConditionalWrap/ConditionalWrap";
var Select = React.forwardRef(function Select(_a, ref) {
    var children = _a.children, useInlineTheme = _a.useInlineTheme, otherProps = __rest(_a, ["children", "useInlineTheme"]);
    return (_jsx(ConditionalWrap, { condition: !!useInlineTheme, wrap: function (children) { return (_jsx("div", { className: "select--inline", children: children })); }, children: _jsx(PrimitiveSelect.Select, __assign({}, (!!useInlineTheme && {
            selectListClass: "select__list--inline",
        }), otherProps, { 
            /* pretty much impossible to have multiple libs with their own box-primitives, agree on interfaces */
            /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
            // @ts-ignore
            ref: ref }, (otherProps.label && {
            button: function (props) { return (_jsx("span", { children: props.value ? props.label : otherProps.label })); },
        }), { children: _jsx(ScrollArea, { height: 400, children: children }) })) }));
});
var Option = function (_a) {
    var children = _a.children, value = _a.value, otherProps = __rest(_a, ["children", "value"]);
    return (_jsx(PrimitiveSelect.Option, __assign({}, otherProps, { value: value, children: children })));
};
export { Select, Option };
